import BrandsComponent from "../../modules/brands/brands";

export default function Brands() {
    return <BrandsComponent role="organization" />;
}